export const landmine = {
  landmineBoard: {},
  boardSize: 10,
  landmineUsers: [],
  turnUser: {},
  gameStatus: false,
  end: false,
  winner: {},
  mineCount: 1,
};

export const davinciCode = {
  davinciCodeArr: [],
  davinciCodeUsers: [],
  gameStatus: false,
  turnUser: {},
  selectCard: {},
  turnStep: 0,
};

// users : []
// front의 마지막 카드가 화면에 보임
// user  : { cards:[],front: [], userId, nickname, end : boolean }

export const halligalli = {
  bellPress: [],
  halligalliUsers: [],
  gameStatus: false,
  turnUser: {},
  // hostUser => 봇을 돌릴 유저
  hostUser: {},
  lastUser: {},
  turnStep: 1,
  gameTurn: 0,
};

// bellPress = { userId, nickname, captureBoard :{} }

// 1 = 카드 뒤집기 or 종내기, 2 = 카드 가져오기 or 나눠주기, 3 = 게임 종료
// 마지막으로 카드를 낸 유저, 본인은

// user  { userId,  }
// turnStep = 1 => 낼 카드를 고른 후 제출 (최초 제출) 어떤 카드인지 같이 선택 필수 or 패스(한장 먹기) => 제출 후 3으로 이동

// turnStep = 2 => 낸 카드 위에 제출 or 패스(한장 먹기) => 제출 후 3으로 이동
// 만약 끊김 없이 모두 패스한 경우 라운드 넘김 투표를 시작할 수 있다. 차례대로 돌아가며 모두가 라운드 넘김 투표할 경우 다음 라운드로 이동
// 라운드 넘김 투표중에 패스 혹은 제출을 할 경우 투표 및 패스 카운터가 초기화

// turnStep = 3 => 엎을지 패스할지 선택, 모두가 패스를 누를경우 다음 차례로, 누군가 엎는다면 step =>5로 이동,
//  이 과정을 통해 제출한 사람의 패가 0이될 경우 해당 유저 end 처리
// pass는 순서대로 한바퀴 진행, 엎는건 먼저 누른 사람이 우선
// 누군가 엎거나 passCount가 전부 채워지면

// turnStep = 4 => 엎은 경우 그동안의 로그들이 전부 밝혀지고 들킨 경우 마지막 카드를 낸 사람이,
//  틀린 경우 엎은 사람이 가져가기 활성화, 가져가기 후 step =>1로 이동

// turnStep = 5 => 모두가 패스 했을 경우 로그가 밝혀지면서 다음 제출할 유저가 라운드 시작 버튼을 누른다. 걸린 사람은 카드 가져오기 클릭

// turnStep = 6 => 게임 종료

// 제출 유저 => submitUser, 라운드 종료 시에는 submitUser를 기준으로 회전

export const fakeCard = {
  fakeCardUsers: [],
  turnUser: {},
  cardArr: [],
  firstCard: "",
  submitUser: {},
  submitLogList: [],
  turnStep: 1,
  gameStatus: false,
  gameTurn: 0,
  passCount: 0,
  voteCount: 0,
  passVoteCount: 0,
};

// fakeCardSubmitList => 제출할 카드 목록들 (redux 변수)
